export default __webpack_public_path__ + "static/media/template3.1b189fae.png";